import ol = require("ol");
import proj4 = require("proj4");
import Portal = require("portal-gis");
import Base = require("./base-command");

// make available to ol (how does ol3 load proj4?)
window["proj4"] = window["proj4"] || proj4;

class Command extends Base<any> {

    static about = `
Adds proj4 projections where each option id is the spatial code (value=definition), e.g.

| id | value |
| --- | --- |
| EPSG:102707 | +proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.9999 +x_0=200000 +y_0=7999999.999999999 +datum=NAD83 +units=us-ft +no_defs |

Usage Example:

\`\`\`xml
<COMMAND about="defines available proj4 projections" id="add-projection" mid="app/commands/add-projection" type="startup">
  <OPTIONS>
    <Values id="EPSG:102113" value="+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs" />
    <Values id="EPSG:3857" value="+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs" />
    <Values id="EPSG:102100" value="+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs" />
  </OPTIONS>
</COMMAND>
\`\`\`

`;
    
    execute(args = this.args) {
        this.configuration.Options.Values.forEach(v => proj4.defs(v.id, v.value));
        this.trigger();
    }

}

export = Command;